module.exports = __webpack_public_path__ + "assets/valance-classic-scallop-short.151486ea.svg";